import { createContext } from 'react'

export const UserDataContext = createContext(null)
